import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "../components/landing/Nav";
import HomeHero from "../components/landing/home2/HomeHero";
import { FeaturedModule, Developments } from "../components/landing/home2/FeaturedModules";
import Footer from "../components/landing/Footer";
import Seo from "../components/Seo";
import { META } from "../lib/seo-meta";
import { langFromPath } from "../lib/routes";
import { SITE } from "../content/site";

export default function Landing() {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  const m = META.home[lang];
  const h = (SITE[lang].home2 || SITE.en.home2);
  useEffect(() => { window.scrollTo(0, 0); }, [lang]);
  return (
    <div data-testid="landing-page" className="bg-white">
      <Seo pageKey="home" lang={lang} title={m.title} description={m.description} image={m.image} />
      <Nav />
      <main id="main">
        <HomeHero />
        <div className="relative z-10 -mt-[10vh] space-y-3 px-0 md:-mt-[14vh]">
          {h.featured.map((f, i) => <FeaturedModule key={f.route} f={f} i={i} />)}
        </div>
        <Developments />
      </main>
      <Footer />
    </div>
  );
}
